import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DoCheck,
    forwardRef,
    Injector,
    Input,
    OnChanges,
    Output,
    ViewChild,
    EventEmitter,
} from '@angular/core';
import {
    ControlValueAccessor,
    NG_VALUE_ACCESSOR,
    NgControl,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Alert, Document } from 'src/app/acl-data/document/document.dto';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import { deepCopy } from 'src/app/acl-data/general/generic.function';

import { AddNotificationDialogComponent } from '../add-notification-dialog/add-notification-dialog.component';

// tslint:disable-next-line: no-conflicting-lifecycle
@Component({
    selector: 'app-event-notification-view',
    templateUrl: './event-notification-view.component.html',
    styleUrls: ['./event-notification-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EventNotificationViewComponent),
            multi: true,
        },
    ],
})
export class EventNotificationViewComponent
    implements OnChanges, ControlValueAccessor, DoCheck {
    alerts: Alert[];
    @Input() addButton = false;
    @Input() objectStore: string;
    @Input() document: Document;

    @Input() notificationChangedFunction;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    tempId = 10000;

    notYetSent = true;
    alreadySent = false;
    trackedTasksOnly = false;

    onChanges = [];
    onTouched = [];
    touched = false;
    disabled = false;

    displayedColumns: string[] = this.addButton
        ? [
              'Action',
              'AlertNotificationNumber',
              'AlertDueDate',
              'AlertEmailAdresses',
              'AlertMessageText',
              'AlertSendDate',
              'AlertTrackTask',
              'AlertTrackComplete',
          ]
        : [
              'AlertNotificationNumber',
              'AlertDueDate',
              'AlertEmailAdresses',
              'AlertMessageText',
              'AlertSendDate',
              'AlertTrackTask',
              'AlertTrackComplete',
          ];
    dataSource;

    constructor(
        public dialog: MatDialog,
        private injector: Injector,
        private documentService: DocumentService,
        private cdr: ChangeDetectorRef
    ) {}

    completeTask = (alertInput: Alert) => {
        const input = deepCopy(alertInput);
        if (this.addButton) {
            input.propertiesObj.AlertTrackComplete = true;
            this.documentService
                .updateAlert(this.objectStore, this.document.id, input)
                .subscribe(v => console.log('Alert Competed', v));
        }
    };

    delete = element => {
        console.log('Deleting', element);
        this.alerts = this.alerts.filter(v => v !== element);
        this.displayChange();
        this.formChanged(this.alerts);

        if (!!this.notificationChangedFunction) {
            const delObj = { ...element };
            delObj.propertiesObj.AlertCancelled = true;
            this.notificationChangedFunction(
                delObj,
                this.objectStore,
                this.document.id
            );
        }
    };

    displayChange() {
        if (this.alerts) {
            this.dataSource = new MatTableDataSource<Alert>(
                this.alerts
                    .filter(
                        v =>
                            !(
                                v.propertiesObj.AlertSystem ||
                                v.propertiesObj.AlertCancelled
                            )
                    )
                    .filter(
                        v =>
                            (this.notYetSent &&
                                !v.propertiesObj.AlertSendDate) ||
                            (this.alreadySent && v.propertiesObj.AlertSendDate)
                    )
                    .filter(
                        v =>
                            !this.trackedTasksOnly ||
                            !!v.propertiesObj.AlertTrackTask
                    )
            );
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    ngOnChanges() {
        this.displayedColumns = this.addButton
            ? [
                  'Action',
                  'AlertNotificationNumber',
                  'AlertDueDate',
                  'AlertEmailAdresses',
                  'AlertMessageText',
                  'AlertSendDate',
                  'AlertTrackTask',
                  'AlertTrackComplete',
              ]
            : [
                  'AlertNotificationNumber',
                  'AlertDueDate',
                  'AlertEmailAdresses',
                  'AlertMessageText',
                  'AlertSendDate',
                  'AlertTrackTask',
                  'AlertTrackComplete',
              ];
        this.displayChange();
    }

    formChanged = (input: any) => {
        for (const change of this.onChanges) {
            change(input);
        }
    };

    editNotificatoin = (input: Alert) => {
        console.log('Editing: ' + input);
        if (this.addButton) {
            console.log('Editing ', input);

            const copyInput = deepCopy(input);

            const dialogRef = this.dialog.open(AddNotificationDialogComponent, {
                width: '80%',
                // height: '80%',
                data: copyInput,
            });

            dialogRef.afterClosed().subscribe(result => {
                console.log('After Editing: ' + result);
                if (!!result) {
                    console.log('Alert changed', result);
                    this.alerts = [
                        result,
                        ...this.alerts.filter(v => v.id !== input.id),
                    ];
                    this.formChanged(this.alerts);
                    this.displayChange();

                    if (!!this.notificationChangedFunction) {
                        this.notificationChangedFunction(
                            result,
                            this.objectStore,
                            this.document.id
                        );
                    }
                }
            });
        }
    };

    addNotification = (input: any) => {
        console.log('Adding Notification');
        const dialogRef = this.dialog.open(AddNotificationDialogComponent, {
            width: '80%',
            // height: '80%',
            data: {
                propertiesObj: {
                    AlertTemplatename: 4,
                },
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!!result) {
                if (!this.alerts) {
                    this.alerts = [];
                }
                if (!result.id) {
                    result.id = `TEMP${this.tempId++}`;
                }
                this.alerts = [result, ...this.alerts];
                this.formChanged(this.alerts);
                this.displayChange();
                if (!!this.notificationChangedFunction) {
                    console.log('Calling change function');
                    this.notificationChangedFunction(
                        result,
                        this.objectStore,
                        this.document.id
                    );
                }
            }
        });
    };

    writeValue(obj: Alert[]): void {
        if (obj && obj.length > 0) {
            this.alerts = obj;
            this.displayChange();
        }
    }

    ngDoCheck() {
        const ngControl = this.injector.get(NgControl);
        if (!ngControl.control) {
            return;
        }
        this.touched = ngControl.control.touched;
    }

    private setOnChangeCallback(fn: any) {
        this.onChanges.push(fn);
    }

    private setOnTouchCallback(fn: any) {
        this.onTouched.push(fn);
    }

    setIsDisabled(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // console.log('registerOnChange');
        this.setOnChangeCallback(fn);
    }
    registerOnTouched(fn: any): void {
        this.setOnTouchCallback(fn);
    }
    setDisabledState?(isDisabled: boolean): void {
        this.setIsDisabled(isDisabled);
    }
}
